import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import './index.scss';
import Input from 'b2b-ui-components-lib/lib/components/input';
import Button from 'b2b-ui-components-lib/lib/components/button';
import { emailValidaotr, otpValidator } from 'common/utils/validator';
import { getLoginOtp, loginOtpVerify } from 'common/helper/api.helper';

import { findParamFromUrl, removeFromSessionStorage, trackAnalytics } from 'common/utils/app.utils';
import { GENERIC_ERROR_MESSAGE, ROUTES } from 'common/constants/app.constants';
import { saveOvToken } from 'tokenGeneration/lead.util';
import { MODULE_ID, OV_TOKEN } from 'tokenGeneration/constant';
import { fetchOrderDetailsAsync } from '../services';

const LoginComponent = () => {
  const history = useHistory();

  const [email, setEmail] = useState(findParamFromUrl('email'));
  const [otp, setOTP] = useState('');
  const [emailVerified, setEmailVerified] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [otpError, setOtpError] = useState('');
  const [loader, showLoader] = useState(false);
  const [seconds, setSeconds] = useState(0);

  const handleGetOTPClick = () => {
    if (emailValidaotr(email).length === 0) {
      getLoginOtp({
        recipient: {
          recipientType: 'EMAIL',
          email: email
        }
      })
        .then((res) => {
          setEmailError('');
          setEmailVerified(true);
          setSeconds(60);
          trackAnalytics({
            eVar9: `b2b|edl|internet|buy|site readiness|get otp`,
            prop15: email
          });
        })
        .catch((error) => {
          const errorMsg = (error && error.response && error.response.data && error.response.data.status && error.response.data.status.message) || GENERIC_ERROR_MESSAGE;
          setEmailError(errorMsg);
        });
    } else {
      setEmailVerified(false);
    }
  };
  const fetchOrderDetails = async () => {
    try {
      showLoader(true);
      const res = await fetchOrderDetailsAsync();
      if (res?.status === 200) {
        showLoader(false);
        const data = res?.data?.result;
        redirectToOrderDetailsPage(data);
      }
    } catch (error) {
      showLoader(false);

      if (error?.response?.status === 401) {
        history?.push(`${ROUTES.EXPRESS_DELIVERY_PAGE_LOGIN}?orderId=${findParamFromUrl('orderId')}`);
      } else {
        const errorMsg = (error && error.response && error.response.data && error.response.data.status && error.response.data.status.message) || GENERIC_ERROR_MESSAGE;
        setOtpError(errorMsg);
      }
    }
  };
  const redirectToOrderDetailsPage = (data) => {
    const pageRoute = `${ROUTES.EXPRESS_DELIVERY_PAGE_ORDER}?orderId=${findParamFromUrl('orderId')}`;
    history.push(pageRoute, { orderData: data });
  };

  const handleVerifyClick = () => {
    if (otpValidator(otp, 4).length === 0) {
      loginOtpVerify(
        {
          otpCode: otp,
          recipient: email
        },
        {
          orderId: findParamFromUrl('orderId')
        }
      )
        .then((res) => {
          const authorization = res && res.headers && res.headers.Authorization ? res.headers.Authorization : res && res.headers && res.headers.authorization;
          setOtpError('');
          setOtpVerified(true);
          saveOvToken(authorization);
          fetchOrderDetails();
          trackAnalytics({
            eVar9: `b2b|edl|internet|buy|site readiness|verify email`,
            prop15: email
          });
        })
        .catch((error) => {
          const errorMsg = (error && error.response && error.response.data && error.response.data.status && error.response.data.status.message) || GENERIC_ERROR_MESSAGE;
          setOtpError(errorMsg);
        });
    } else setOtpVerified(false);
  };
  useEffect(() => {
    removeFromSessionStorage(MODULE_ID, OV_TOKEN);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [seconds]);
  const checkFieldDisabled = () => {
    let status = true;
    if (emailVerified) {
      status = !(otp && otpValidator(otp, 4).length === 0);
    } else {
      status = !(email && emailValidaotr(email).length === 0);
    }
    return status;
  };
  return (
    <div className="login-container">
      <div className="login-box">
        <div className="title-container">
          <div className="title">OTP Verification</div>
          <div className="sub_title">Verify email address via OTP to edit site details.</div>
        </div>
        <div className="field-container">
          <Input
            type="email"
            label="Email Address"
            value={email}
            required={true}
            onChange={(value) => {
              setEmail(value);
            }}
            isValidChange={(value) => emailValidaotr(value)}
            disabled={emailVerified}
          />
          {emailVerified && (
            <div className="icon-container">
              <span
                className="edit_icon"
                onClick={() => {
                  setEmailVerified(false);
                  setOTP('');
                  setOtpError('');
                }}
              >
                Edit
              </span>
            </div>
          )}
          {emailError && <div className="error-msg">{emailError}</div>}
        </div>

        {emailVerified && (
          <div className="field-container">
            <Input
              type="tel"
              maxLength={4}
              onKeyDown={(event) => {
                if (isNaN(event.key) && event.key !== 'Backspace') {
                  event.preventDefault();
                  return;
                }
                setOtpError('');
              }}
              label="OTP"
              value={otp}
              required={true}
              onChange={(value) => {
                setOTP(value);
              }}
            />
            <div className="icon-container">
              <span
                className="cross_icon"
                onClick={() => {
                  setOTP('');
                  setOtpError('');
                }}
              ></span>
            </div>
          </div>
        )}
        {emailVerified && otpError && <div className="error-msg">{otpError}</div>}
        <div className="button-container">
          <Button type="button" disabled={checkFieldDisabled() || loader ? true : false} onClick={emailVerified ? handleVerifyClick : handleGetOTPClick}>
            <div className={loader && 'loader_css'}>
              <span>{emailVerified ? 'Verify' : 'Get OTP'}</span>
              {loader && <span className="loading_icon"></span>}
            </div>
          </Button>

          {emailVerified && (
            <div className="resend-button">
              <Button
                type="button"
                variant="large_transparentbtn"
                disabled={seconds > 0}
                displayName={seconds === 0 ? 'Resend OTP' : `Resend OTP in ${seconds}s`}
                onClick={handleGetOTPClick}
              ></Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginComponent;
